import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../App';
export { createDeck, shuffleDeck } from '../utils/CardUtils';

export const evaluateHand = (hand) => {
  const suits = {};
  const values = {};

  hand.forEach(card => {
    if (!suits[card.suit]) suits[card.suit] = 0;
    if (!values[card.value]) values[card.value] = 0;
    suits[card.suit]++;
    values[card.value]++;
  });

  const valueCounts = Object.values(values).sort((a, b) => b - a);
  const uniqueValues = Object.keys(values).sort((a, b) => {
    const valueOrder = ['2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K', 'A'];
    return valueOrder.indexOf(a) - valueOrder.indexOf(b);
  });

  const isFlush = Object.keys(suits).length === 1;
  const isStraight = uniqueValues.length === 5 &&
    (['A', '2', '3', '4', '5'].join('') === uniqueValues.join('') ||
    uniqueValues.slice(-5).every((v, i, arr) => !i || arr[i - 1] === values.indexOf(v) - 1));

  const highCard = uniqueValues[uniqueValues.length - 1];
  const pair = valueCounts.includes(2);
  const threeOfKind = valueCounts.includes(3);
  const fourOfKind = valueCounts.includes(4);
  const fullHouse = threeOfKind && pair;

  if (isFlush && isStraight && highCard === 'A') return { rank: 9, highCard };
  if (isFlush && isStraight) return { rank: 8, highCard };
  if (fourOfKind) return { rank: 7, highCard };
  if (fullHouse) return { rank: 6, highCard };
  if (isFlush) return { rank: 5, highCard };
  if (isStraight) return { rank: 4, highCard };
  if (threeOfKind) return { rank: 3, highCard };
  if (pair === 2) return { rank: 2, highCard }; 
  if (pair === 1) return { rank: 1, highCard };

  return { rank: 0, highCard };
};

export const dealCommunityCards = async (gameId, numberOfCards, gameData) => {
  const newCommunityCards = [...(gameData.communityCards || [])];
  const newDeck = [...gameData.deck];
  for (let i = 0; i < numberOfCards; i++) {
    newCommunityCards.push(newDeck.pop());
  }

  await updateDoc(doc(db, 'games', gameId), {
    communityCards: newCommunityCards,
    deck: newDeck,
  });
};
